module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-rows wrap"
  }, [_c('div', {
    staticClass: "product-row"
  }, [_c('img', {
    staticClass: "product-image",
    attrs: {
      "src": _vm.getUrlImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-product"
  }, [_c('p', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.getProductName))]), _vm._v(" "), _c('p', {
    staticClass: "product-description"
  }, [_vm._v(_vm._s(_vm.item.description))]), _vm._v(" "), _c('p', {
    staticClass: "product-code"
  }, [_vm._v("#" + _vm._s(_vm.getProductCode))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-434fa066","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rowsTable.vue
// module id = 1104
// module chunks = 36